import { z } from 'zod';

export const DocumentCategory = z.enum([
  'declaration',
  'letters_patent',
  'bylaws',
  'servitudes',
  'minutes',
  'insurance',
  'contingency_study',
  'logbook',
  'financial_statements',
  'notice',
  'other',
]);
export const Visibility = z.enum(['board', 'members']);

export const DocumentMetadata = z.object({
  title: z.string().trim().min(1).max(200),
  category: DocumentCategory,
  visibility: Visibility,
  documentDate: z.iso.date().optional(),
});
export type DocumentMetadata = z.infer<typeof DocumentMetadata>;

export const SearchQuery = z.object({ q: z.string().trim().min(2).max(300), limit: z.coerce.number().int().min(1).max(20).default(8) });

export const ACCEPTED_TYPES = ['application/pdf', 'text/plain', 'text/markdown'] as const;
export const MAX_BYTES = 20 * 1024 * 1024;

export interface DocumentSummary {
  id: string;
  title: string;
  category: z.infer<typeof DocumentCategory>;
  visibility: z.infer<typeof Visibility>;
  documentDate: string | null;
  fileName: string;
  contentType: string;
  sizeBytes: number;
  pageCount: number;
  uploadedAt: string;
}

/** A passage found by search: what an answer cites. */
export interface Passage {
  documentId: string;
  title: string;
  category: z.infer<typeof DocumentCategory>;
  pageNo: number;
  /** The page's text (for the model) and a short highlighted excerpt (for people). */
  text: string;
  excerpt: string;
  rank: number;
}
